
import { Mixins, Component, Prop } from 'vue-property-decorator';
import {
  Pagination,
  Button,
  Card,
  Form,
  FormItem,
  Dialog,
  Input,
  Tooltip,
} from 'element-ui';
import { tSearch } from '@/components/Search';
import api from '@/api/video';
import BsMixin from '@/views/Home/mixins/bsMixin';
import BScroll from 'better-scroll';
import pageMixin from '../../../mixins/pageMixin';

  @Component({
    components: {
      Pagination,
      tSearch,
      Button,
      Card,
      Form,
      FormItem,
      Dialog,
      Input,
      Tooltip,
    },
  })
export default class Setting extends Mixins(pageMixin, BsMixin) {
    @Prop({
      required: true,
      default: false,
    })videoList!: any;

    private bs?: BScroll;

    private visible = false;

    private rules: any = {
      title: [
        { required: true, message: '请输入视频标题', trigger: 'blur' },
      ],
    }

    private form: any = {
      title: '',
      description: '',
      videoId: '',
      cateId: '',
    }

    public $refs!:{
      videoList: Element,
      videoWrapper: Element,
      form: Form,
    }

    mounted() {
      this.initBS(this.$refs.videoList, {
        click: false,
      });
      this.bs = this.initBS(this.$refs.videoList);
      this.bs.on('scrollEnd', (cood: any) => {
        if (cood.y === 0) return;
        const contentHeight: number = this.$refs.videoList.clientHeight;
        const wrapperHeight: number = Math.abs(this.$refs.videoWrapper
          .getBoundingClientRect().height);
        if (contentHeight + Math.abs(cood.y) > wrapperHeight - 10) {
          this.$emit('getScrollData');
        }
      });
    }

    updataVideo(item: any) {
      this.visible = true;
      this.form.videoId = item.videoPath;
    }

    updateSubmit() {
      this.$refs.form.validate((valid: any) => {
        if (valid) {
          api.updateVideo(this.form).then((res: any) => {
            this.$emit('getVideoData');
            this.visible = false;
            this.form = {};
          });
        } else {
          return false;
        }
        return true;
      });
    }

    removeVideo(item: any) {
      this.confirm('你确定要删除该视频吗?', {
        title: '警告',
        loading: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconType: 'warning',
      }).then((close: Function) => {
        api.removeVideo(item.pid).then((res: any) => {
          this.$emit('getVideoData');
          close();
          this.$log({
            title: '正式课管理 - 删除 - 确定',
            component: 'trial/manage/bModal',
          });
        }).catch(() => {
          close();
        });
      }).catch((close: Function) => {
        close();
        this.$log({
          title: '正式课管理 - 删除 - 取消',
          loading: false,
          component: 'trial/manage/bModal',
        });
      });
    }

    dialogClose() {
      this.form = {};
    }

    refreshForm() {
      this.$refs.form.resetFields();
    }

    /* eslint-disable class-methods-use-this */
    playVide(video: any) {
      api.playVideo(video.videoPath).then((res: any) => {
        const videoId1 = res.videoMeta.videoId;
        const playAuth1 = res.playAuth;
        window.open(`playVideo.html?videoId=${videoId1}&playAuth=${playAuth1}`);
      });
    }
}
